import { createContext } from 'react';

interface MyUtilitiesAppContext {
  routes: any[];
}

const AppContext = createContext<MyUtilitiesAppContext>({
  routes: [],
});

export default AppContext;
